import { Type, plainToInstance } from 'class-transformer'
import { FolderPath } from '@core/entities/folders/FolderResponse'
import { Entity } from '@core/entities/entity'
import { User } from '@core/entities/user'
import { IProcoreDocumentVersionBase } from './IProcoreDocumentVersionBase'

export class ProcoreDocumentVersionBase<
  ExtendedType extends IProcoreDocumentVersionBase = IProcoreDocumentVersionBase,
> extends Entity<ExtendedType> {
  id: number
  documentId: number
  documentVersion: number
  documentGetUrl: string
  documentDownloadUrl: string

  @Type(() => User)
  modifiedBy: User

  modifiedOn: string

  @Type(() => User)
  createdBy: User

  createdOn: string

  folder: {
    folderId: number
    pathFromRoot: FolderPath
  }

  public static new(
    payload: IProcoreDocumentVersionBase,
  ): ProcoreDocumentVersionBase {
    const entity = plainToInstance<
      ProcoreDocumentVersionBase,
      IProcoreDocumentVersionBase
    >(ProcoreDocumentVersionBase, payload)

    return entity
  }
}
